import api from './api';

// boardId: orden de columnas de ese tablero. Sin boardId, el orden general
// (comportamiento anterior a los tableros).
export const setKanbanLaneOrder = async (laneOrder, boardId) => {
  try {
    const response = await api.post('/company-kanban/lane-order', {
      laneOrder,
      ...(boardId ? { boardId } : {})
    });
    return response.data;
  } catch (error) {
    console.error('Error setting kanban lane order:', error);
    throw error;
  }
};

export const getKanbanLaneOrder = async (boardId) => {
  try {
    const response = await api.get('/company-kanban/lane-order', {
      params: boardId ? { boardId } : {}
    });
    return response.data.laneOrder;
  } catch (error) {
    console.error('Error getting kanban lane order:', error);
    return null;
  }
};
